<template>
  <div class="embedded">
    <transition name="fadeout">
      <div v-if="!ticketClosed && !closingWidget" class="ticket-open">
        <p class="header">{{ heading }}</p>
        <p
          class="body"
          :class="{
            'wider-languages': language === 'fr' || language === 'it' || language === 'pt',
          }"
        >
          {{ subheading }}
        </p>
        <div class="line"></div>
        <div class="button-container">
          <b-button
            variant="outline-primary"
            class="widget-buttons"
            :class="{
              'widget-buttons-wider-languages': language === 'fr' || language === 'it' || language === 'pt',
            }"
            v-on:click="closeTicket"
            >{{ yesButton }}</b-button
          >
          <b-button
            variant="outline-primary"
            class="widget-buttons"
            :class="{
              'widget-buttons-wider-languages': language === 'fr' || language === 'it' || language === 'pt',
            }"
            v-on:click="doNotSolveTicket"
            >{{ noButton }}</b-button
          >
        </div>
      </div>
    </transition>
    <transition name="fadein">
      <div v-if="closingWidget" class="ticket-open">
        <p class="follow-up" :class="{ es: language === 'es' }">
          {{ followUpQuestion }}
        </p>
        <div class="line"></div>
        <div
          class="follow-up-button-container"
          :class="{
            'follow-up-button-container-wider-languages': language === 'fr' || language === 'it' || language === 'pt',
          }"
        >
          <b-button
            variant="outline-primary"
            class="follow-up-buttons"
            :class="{
              'follow-up-wider-languages': language === 'fr' || language === 'it' || language === 'pt',
              'es-button-login': language === 'es' && linkId === 'MALogin',
              'es-button': language === 'es',
              'it-button': language === 'it',
            }"
            v-on:click="followUp(followUpOption1TrackingId)"
            >{{ followUpOption1 }}</b-button
          >
          <b-button
            variant="outline-primary"
            class="follow-up-buttons"
            :class="{
              'follow-up-wider-languages': language === 'fr' || language === 'it' || language === 'pt',
              'es-button-login': language === 'es' && linkId === 'MALogin',
              'es-button': language === 'es',
              'it-button': language === 'it',
            }"
            v-on:click="followUp(followUpOption2TrackingId)"
            >{{ followUpOption2 }}</b-button
          >
        </div>
      </div>
    </transition>
    <transition name="fadein">
      <div v-if="ticketClosed" class="ticket-closed">
        <b-button v-on:click="closeWidget" variant="outline" class="close-widget-button">
          <b-icon icon="x"></b-icon>
        </b-button>
        <div class="align">
          <b-icon icon="check-circle" class="close-check"></b-icon>
          <p class="closed-ticket">{{ solved }}</p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import axios from 'axios';
import { csbpApi } from '@/config/index.js';
export default {
  name: 'Embed',
  data() {
    return {
      siteName: '',
      ticketId: '',
      language: '',
      requesterId: '',
      linkId: '',
      url: '',
      ticketClosed: false,
      closingWidget: false,
      skipFollowUp: false,
      heading: '',
      subheading: '',
      yesButton: '',
      noButton: '',
      solved: '',
      followUpQuestion: '',
      followUpOption1: '',
      followUpOption2: '',
      followUpOption1TrackingId: '',
      followUpOption2TrackingId: '',
    };
  },
  methods: {
    getFollowUpDetails() {
      // Set up the follow up setting object like this to keep the tracking ids with the text options
      let followUpSettings = {
        HFCXL: {
          option1: {
            trackingId: 'FollowUpWrongEmailHFCXL',
            'en-us': "I don't remember my email",
            fr: 'Je ne me souviens pas de mon email',
            es: 'No recuerdo mi email',
            it: 'Non ricordo la mia e-mail',
            pt: 'Não me lembro do meu email',
            ja: 'メールを覚えていない',
          },
          option2: {
            trackingId: 'FollowUpWrongPasswordHFCXL',
            'en-us': "I don't remember my password",
            fr: 'Je ne me souviens plus de mon mot de passe',
            es: 'No recuerdo mi contraseña',
            it: 'Non ricordo la mia password',
            pt: 'Não lembro minha senha',
            ja: 'パスワードを覚えていません',
          },
        },
        MALogin: {
          option1: {
            trackingId: 'FollowUpWrongEmailMALogin',
            'en-us': 'My email address is incorrect',
            fr: 'Mon adresse e-mail est incorrecte',
            es: 'Mi dirección de correo electrónico es incorrecta',
            it: 'Il mio indirizzo e-mail non è corretto',
            pt: 'Meu endereço de email está incorreto',
            ja: '私のメールアドレスが間違っています',
          },
          option2: {
            trackingId: 'FollowUpWrongPasswordMALogin',
            'en-us': 'My password is incorrect',
            fr: 'Mon mot de passe est incorrect',
            es: 'Mi contraseña es incorrecta',
            it: 'La mia password non è corretta',
            pt: 'Minha senha esta incorreta',
            ja: 'パスワードが間違っています',
          },
        },
        ChargeQuery: {
          option1: {
            trackingId: 'FollowUpUnauthorizedCardChargeQuery',
            'en-us': 'Unauthorized Credit Card Use',
            fr: 'Utilisation non autorisée de la carte de crédit',
            es: 'Uso de tarjeta de crédito no autorizado',
            it: 'Utilizzo non autorizzato della carta di credito',
            pt: 'Uso não autorizado de cartão de crédito',
            ja: 'クレジットカードの不正使用',
          },
          option2: {
            trackingId: 'FollowUpPostCancelChargeQuery',
            'en-us': 'I was charged after I cancelled',
            fr: "J'ai été facturé après avoir annulé",
            es: 'Me cobraron después de cancelar',
            it: 'Mi è stato addebitato un importo dopo la cancellazione',
            pt: 'Fui cobrado depois de cancelar',
            ja: 'キャンセル後に請求されました',
          },
        },
      };
      if (followUpSettings[this.linkId]) {
        let followUpGroupOption1 = followUpSettings[this.linkId].option1;
        let followUpGroupOption2 = followUpSettings[this.linkId].option2;

        //Get tracking link ids for followups
        this.followUpOption1TrackingId = followUpGroupOption1.trackingId ? followUpGroupOption1.trackingId : null;
        this.followUpOption2TrackingId = followUpGroupOption2.trackingId ? followUpGroupOption2.trackingId : null;

        //Get text for option 1 & 2
        this.followUpOption1 = followUpGroupOption1[this.language] ? followUpGroupOption1[this.language] : followUpGroupOption1['en-us'];
        this.followUpOption2 = followUpGroupOption2[this.language] ? followUpGroupOption2[this.language] : followUpGroupOption2['en-us'];
        return;
      }
      // Making it skip the follow up section if no follow up is found
      this.skipFollowUp = true;
      return;
    },
    messageLanguage() {
      let message = {
        'en-us': {
          heading: 'Does this article answer your question?',
          subheading: 'If it does, we can close your recent request',
          yesButton: 'Yes, This resolved my issue',
          noButton: 'No',
          solved: 'Your request has been closed',
          followUpQuestion: 'Please tell us why.',
        },
        fr: {
          heading: 'Cet article répond-il à votre question?',
          subheading: 'Si tel est le cas, nous pouvons fermer votre demande récente',
          yesButton: 'Oui, cela a résolu mon problème',
          noButton: 'Non',
          solved: 'Votre demande a été clôturée',
          followUpQuestion: 'Veuillez nous dire pourquoi.',
        },
        it: {
          heading: 'Questo articolo risponde alla tua domanda?',
          subheading: 'In tal caso, possiamo chiudere la tua recente richiesta',
          yesButton: 'Sì, questo ha risolto il mio problema',
          noButton: 'No',
          solved: 'La tua richiesta è stata chiusa',
          followUpQuestion: 'Per favore, dicci perché.',
        },
        pt: {
          heading: 'Este artigo responde à sua pergunta?',
          subheading: 'Em caso afirmativo, podemos encerrar sua solicitação recente',
          yesButton: 'Sim, isso resolveu meu problema',
          noButton: 'Não',
          solved: 'Sua solicitação foi fechada',
          followUpQuestion: 'Diga-nos por quê.',
        },
        es: {
          heading: '¿Este artículo responde a tu pregunta?',
          subheading: 'Si es así, podemos cerrar su solicitud reciente.',
          yesButton: 'Sí, esto resolvió mi problema',
          noButton: 'No',
          solved: 'Tu solicitud ha sido cerrada',
          followUpQuestion: 'Por favor díganos por qué.',
        },
        ja: {
          heading: 'この記事はあなたの質問に答えますか？',
          subheading: '一致する場合は、最近のリクエストをクローズできます',
          yesButton: 'はい、これで問題が解決しました',
          noButton: '番号',
          solved: 'リクエストはクローズされました',
          followUpQuestion: '理由を教えてください。',
        },
      };
      let resultMessage = message[this.language];
      if (!resultMessage) {
        resultMessage = message['en-us'];
      }
      this.heading = resultMessage.heading;
      this.subheading = resultMessage.subheading;
      this.yesButton = resultMessage.yesButton;
      this.noButton = resultMessage.noButton;
      this.solved = resultMessage.solved;
      this.followUpQuestion = resultMessage.followUpQuestion;
      this.unrelated = resultMessage.unrelated;
      this.relatedButUnhelpful = resultMessage.relatedButUnhelpful;
      return;
    },
    async followUp(followupTracking) {
      this.closeWidget();
      await axios.get(`${csbpApi}/zendesk/ct?ticket_id=${this.ticketId}&link_id=${followupTracking}&link=${encodeURIComponent(this.url)}`);
    },
    async doNotSolveTicket() {
      if (this.skipFollowUp) {
        this.closeWidget();
      }
      this.closingWidget = true;
      await axios.get(`${csbpApi}/zendesk/ct?ticket_id=${this.ticketId}&link_id=CloseWidget${this.linkId}&link=${encodeURIComponent(this.url)}`);
    },
    closeWidget() {
      if (window.parent) {
        window.parent.postMessage('closeWindow', '*');
      }
    },
    async closeTicket() {
      this.ticketClosed = true;
      await this.solveTicket();
      if (window.parent) {
        window.parent.postMessage('closeTicket', '*');
      }
    },
    getVariables() {
      this.siteName = this.$route.query.siteName ? this.$route.query.siteName : null;
      this.ticketId = this.$route.query.ticketId ? this.$route.query.ticketId : null;
      this.language = this.$route.query.language ? this.$route.query.language : null;
      this.requesterId = this.$route.query.code ? this.$route.query.code : null;
      this.linkId = this.$route.query.linkId ? this.$route.query.linkId : null;
      this.url = this.$route.query.url ? this.$route.query.url : null;
    },
    getUrlVariable() {
      if (event.data && event.data.updatedUrl) {
        this.url = event.data.updatedUrl;
      }
    },
    async solveTicket() {
      if (!this.ticketId || !this.requesterId) {
        console.error('no ticket id or code');
        return;
      }
      try {
        let [response, tracking] = await Promise.all([
          axios.post(`${csbpApi}/zendesk/ticket/${this.ticketId}/solve`, { requesterId: this.requesterId }, { headers: { 'Content-Type': 'application/json' } }),
          axios.get(`${csbpApi}/zendesk/ct?ticket_id=${this.ticketId}&link_id=SolveTicketWidget${this.linkId}&link=${encodeURIComponent(this.url)}`),
        ]);
        return response;
      } catch (error) {
        console.error(error);
        return;
      }
    },
  },
  created() {
    this.getVariables();
    this.messageLanguage();
    window.addEventListener('message', this.getUrlVariable);
    this.getFollowUpDetails();
  },
  components: {},
};
</script>
<style scoped>
.embedded {
  background-color: white;
  height: 100%;
  width: 100%;
  margin: auto;
}

p {
  font-size: 0.875rem;
  text-align: left;
  font-family: Helvetica, Arial, sans-serif;
}
p.header {
  margin: 0px 0px 0px 20px;

  padding-top: 0.5rem;
  font-weight: bold;
}
p.body {
  margin: 15px 0px 15px 20px;
}

.fadeout-enter-active,
.fadeout-leave-active {
  transition: opacity 0.5s;
}
.fadeout-enter,
.fadeout-leave-to {
  opacity: 0;
}

.line {
  border-top: 1px solid rgb(224, 224, 224);
  width: 90%;
  margin: auto;
}

.button-container {
  display: inline-block;
  text-align: right;
  padding-bottom: 2.5rem;
  /* width: 100%; */
}
.widget-buttons {
  /* display: flex; */
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  /* line-height: 30px; */
  border: 1px solid #68737d;
  border-radius: 2px;
  color: #68737d;
  margin-left: 10px;
  margin-top: 10px;
}
.widget-buttons-wider-languages {
  padding-top: 5px;
  padding-bottom: 5px;
}
.widget-buttons:hover {
  color: white;
  background-color: #68737d;
}
.widget-buttons:focus {
  color: white;
  background-color: #68737d;
  border: 1px solid #68737d;
}
.widget-buttons.right-button {
  width: 50px;
  text-align: center;
  margin-right: 20px;
}
.link {
  color: #68737d;
  text-decoration: none;
}

/**.Follow up page styles */
.follow-up-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
  width: 100%;
  /* line-height: 30px; */
  border: 1px solid #68737d;
  border-radius: 5px;
  color: #68737d;
  /* margin-left: 10px;*/
  margin: auto;
  margin-top: 5px;
}
.follow-up-buttons:hover {
  color: white;
  background-color: #68737d;
}
.follow-up-buttons:focus {
  color: white;
  background-color: #68737d;
  border: 1px solid #68737d;
}
p.follow-up {
  padding: 15px 0px 0px 20px;
  margin-bottom: 2px;
}
.follow-up-button-container {
  display: inline-block;
  width: 80%;
  padding-bottom: 50px;
}
.follow-up-button-container-wider-languages {
  width: 90%;
}
.follow-up-wider-languages {
  padding-top: 6px;
  padding-bottom: 6px;
}
.es-button {
  padding: 7px 5px 7px 5px;
}
/**Close widget page styles */

.fadein-enter-active,
.fadein-leave-active {
  transition: opacity 0.5s;
  transition-delay: 0.5s;
}
.fadein-enter,
.fadein-leave-to {
  opacity: 0;
}
.ticket-closed {
  height: 100%;
}
p.closed-ticket {
  text-align: center;
  font-size: 1.125rem;
  color: gray;
  padding-bottom: 2em;
}
.close-check {
  margin-bottom: 0.25em;
  font-size: 3rem;
  color: #969e65;
}
.close-widget-button {
  float: right;

  margin-top: 0rem;
  margin-bottom: 0rem;
  font-size: 1.5em;
  color: grey;
}
.align {
  display: inline-block;
  width: 100%;
}
@media (width: 398px) {
  p.header {
    padding-top: 2.5rem;
  }
  .close-widget-button {
    margin-top: 0.625rem;
    margin-bottom: 0.25em;
  }
  .close-check {
    font-size: 4rem;
  }
  p.follow-up {
    padding: 15px 0px 15px 20px;
  }
  .follow-up-buttons {
    margin-top: 10px;
  }
  .widget-buttons-wider-languages {
    margin-top: 10px;
    padding: 10px 20px 10px 20px;
  }
  .follow-up-wider-languages {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .es-button {
    padding: 10px 5px 10px 5px;
  }
}

@media (max-width: 348px) {
  p.header {
    padding-top: 0.5rem;
  }
  p.body.wider-languages {
    margin: 5px 0px 5px 20px;
  }
  .close-widget-button {
    margin-top: 0.625rem;
    margin-bottom: 0.25rem;
    font-size: 1rem;
  }
  .close-check {
    font-size: 3rem;
  }
  .widget-buttons {
    padding-left: 5px;
    padding-right: 5px;
    line-height: 20px;
    margin-left: 5px;
    margin-top: 10px;
  }
  p.closed-ticket {
    font-size: 1rem;
    color: gray;
  }
  .follow-up-button-container {
    width: 90%;
  }
  .widget-buttons-wider-languages {
    padding-left: 2px;
    padding-right: 2px;
    padding-top: 5px;
    padding-bottom: 5px;
    margin-top: 5px;
  }
  .it-button {
    padding: 2px 5px 2px 5px;
  }
}
@media (max-width: 358px) {
  .widget-buttons-wider-languages {
    margin-left: 5px;
  }
}
@media (max-width: 280px) {
  .widget-buttons-wider-languages {
    margin-left: 2px;
  }
  .follow-up-button-container-wider-languages {
    width: 98%;
  }
  .follow-up-wider-languages {
    padding: 2px 2px 2px 2px;
  }
  .es {
    padding-top: 5px;
  }
  .es-button-login {
    padding: 5px 5px 5px 5px;
  }
}
</style>
